import React from 'react';
import './UsaPerksBenefits.css';

const UsaPerksBenefits = () => {
  return (
    <section className="usa-perks-benefits" id="perks-benefits">
      <div className="usa-perks-benefits__container">
        {/* Badge */}
        <div className="usa-perks-benefits__badge">
          <svg aria-hidden="true" className="usa-perks-benefits__badge-icon" viewBox="0 0 640 512" width="20" height="20" fill="#006100">
            <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
          </svg>
          <span>Benefits</span>
        </div>

        {/* Main Section Title */}
        <h2 className="usa-perks-benefits__title">
          Perks and Benefits When Enrolling In Our Online Quran Classes
        </h2>

        {/* Description Paragraph */}
        <p className="usa-perks-benefits__desc">
          Al Quran Lesson forms engaging learning experiences. We build genuine interest in Quranic education and offer comfortable environments where your kid feels supported and motivated. We combine traditional values with modern teaching approaches and present the best online Quran classes in the USA that build confidence and spiritual connection. Every session encourages curiosity and helps you develop a lasting appreciation for Islamic teachings through personalized attention and expert guidance.
        </p>
      </div>
    </section>
  );
};

export default UsaPerksBenefits;
